export default {
  actionAdimplencia({commit}, adimplencia){
    commit("setAdimplencia", adimplencia)
  }
}
